import { AppContext } from '@/context/AppContext';
import { useContext } from 'react';
import { Icon } from '@/comp/icon/icon';
import BookingDetails from '@/pages/booking-details';
import InfoCard from '@/comp/ui/infoCard/infoCard';

import '@/pages/index/index.scss';

export const Index = () => {
    const { bookingData, bookingState } = useContext(AppContext);

    function bookingDetails() {
        // affiliate
        if (window.$affiliate) {
            return false;
        }

        switch (bookingData?.data.serviceInformation.package.state) {
            case 'OK':
            case 'MO':
            case 'XX':
            case 'TB':
                return <BookingDetails bookingData={bookingData} bookingState={bookingState} />;
            case 'SB':
            case 'RQ':
                return (
                    <InfoCard type="large">
                        <p>
                            Ihre Buchung wird gerade überprüft. Bitte loggen Sie sich zu einem späteren Zeitpunkt noch
                            einmal in den Kundenbereich ein. Danke.
                        </p>
                    </InfoCard>
                );
            default:
                break;
        }
    }

    if (window.$browserInfo && window.$browserInfo.device !== 'mobile') {
        return (
            <div className={`tab-content-container booking-details ${bookingState === 'XX' ? 'booking-xx' : ''}`}>
                {bookingState === 'XX' ? (
                    <>
                        <div className="tab-header">
                            <h3>Ihre Buchung wurde storniert</h3>
                        </div>
                        <p className="booking-alert status-xx">
                            <Icon name="freeCancellation" size={32} ariaHidden />
                            Diese Reise wurde storniert. Weitere Informationen haben Sie per E-Mail erhalten. Bitte
                            wenden Sie sich bei offenen Fragen an das AurumTours Serviceteam.
                        </p>
                    </>
                ) : (
                    window.$browserInfo.device !== 'mobile' && (
                        <>
                            <div className="tab-header">
                                <h3>Buchungsübersicht</h3>
                            </div>
                            {bookingDetails()}
                        </>
                    )
                )}
            </div>
        );
    }
};
